import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
import Swal from 'sweetalert2';
import { ConfirmPayload, SwalService } from '../swal.service';

@Injectable({
  providedIn: 'root',
})
export class VersionDetectService {
  private _showUpdateNotification = new BehaviorSubject<boolean>(false);
  public showUpdateNotification$ = this._showUpdateNotification.asObservable();

  constructor(private cookieService: CookieService, private swalService: SwalService) {}

  showUpdateNotification(): void {
    this._showUpdateNotification.next(true);
  }

  hideUpdateNotification(): void {
    this._showUpdateNotification.next(false);
  }

  hasValidToken(): boolean {
    const token = this.cookieService.get('token');

    if (!token || token.trim() === '') {
      return false;
    }
    return true;
  }

  isUpdatePending(): boolean {
    const updatePending = this.cookieService.get('updatePending') ?? 'false';
    return updatePending === 'true';
  }
  setUpdatePending(pending: boolean): void {
    if (!pending) {
      this.hideUpdateNotification();
    } else {
      this.showUpdateNotification();
    }
    this.cookieService.set('updatePending', pending.toString(), undefined, '/');
  }

  applyUpdate(): void {
    this.setUpdatePending(false);
    this.hideUpdateNotification();
    window.location.reload();
  }
}
